export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const accountTypes = [
  {
    value: "Internal",
    label: "Internal",
  },
  {
    value: "External",
    label: "External",
  },
];

export const accountStatus = [
  {
    value: "Active",
    label: "Active",
  },
  {
    value: "Block",
    label: "Block",
  },
];

export const assignmentList = [
  {
    value: "CIT",
    label: "CIT",
  },
  {
    value: "ATM",
    label: "ATM",
  },
  {
    value: "HUB",
    label: "HUB",
  },
  {
    value: "FLM",
    label: "FLM",
  },
  {
    value: "Customer",
    label: "Customer",
  },
  {
    value: "NA",
    label: "NA",
  },
];

export const CUSTOMER_TYPES = [
  { value: "Bank", label: "Bank" },
  { value: "Retail", label: "Retail" },
  { value: "Exchange House", label: "Exchange House" },
  { value: "Corporate", label: "Corporate" },
  { value: "Hotel", label: "Hotel" },
  { value: "Customer", label: "Customer" },
];

export const CUSTOMER_STATUS = [
  { value: "Active", label: "Active" },
  { value: "In Active", label: "In Active" },
];

export const INSURANCE_TYPE = [
  {
    value: "Cash Center",
    label: "Cash Center",
  },
  {
    value: "Central Bank",
    label: "Central Bank",
  },
  {
    value: "ATM",
    label: "ATM",
  },
  {
    value: "BDM",
    label: "BDM",
  },
  {
    value: "Branch",
    label: "Branch",
  },
  {
    value: "Corporate Customer",
    label: "Corporate Customer",
  },
];

export const contractStatus = [
  { value: "active", label: "Active" },
  { value: "closed", label: "Closed" },
];

export const ESCALATION_LEVELS = [
  { value: "1", label: "Level 1" },
  { value: "2", label: "Level 2" },
  { value: "3", label: "Level 3" },
];

export const SERVICE_TYPES = [
  {
    value: "ATM Replenishment",
    label: "ATM Replenishment",
  },
  {
    value: "Machine Clearance",
    label: "Machine Clearance",
  },
  {
    value: "Cash Collection",
    label: "Cash Collection",
  },
  {
    value: "Cash Delivery",
    label: "Cash Delivery",
  },
  {
    value: "B2B Services",
    label: "B2B Services",
  },
  {
    value: "FLM",
    label: "FLM",
  },
  {
    value: "SLM",
    label: "SLM",
  },
];
export const ACTIVITY_TYPES = [
  {
    label: "First Line Maintenance",
    value: "First Line Maintenance",
  },
  {
    label: "Second Line Maintenance",
    value: "Second Line Maintenance",
  },
  {
    label: "Phone Support",
    value: "Phone Support",
  },
  {
    label: "Rollout Activity PPM",
    value: "Rollout Activity PPM",
  },
  {
    label: "Planned FLM",
    value: "Planned FLM",
  },
  {
    label: "Planned SLM",
    value: "Planned SLM",
  },
  {
    label: "No SLA Activity",
    value: "No SLA Activity",
  },
  {
    label: "Phone Support : SLM",
    value: "Phone Support : SLM",
  },
];
export const CASSETTES_TYPE = [
  {
    value: "Type 1",
    label: "Type 1",
  },
  {
    value: "Type 2",
    label: "Type 2",
  },
  {
    value: "Type 3",
    label: "Type 3",
  },
];
export const DENOMINATION_SHAPE = [
  { value: "Notes", label: "Notes" },
  { value: "Coins", label: "Coins" },
];
export const customerInfoDefault = {
  clientId: "",
  name: "",
  shortName: "",
  customerType: null,
  customerCode: "",
  status: CUSTOMER_STATUS[0],
  hasSeparateDispenseCount: false,
  requiresEVhr: false,
  requestedBy: "",
  comments: "",
};
export const accountDefault = {
  title: "",
  accountNo: "",
  branchCode: "",
  accounts: [],
};

export const contactPersonDefault = {
  firstName: "",
  lastName: "",
  mobileNo: "",
  email: "",
  personalMobileNo: "",
  officeNo: "",
  designation: "",
};

export const insuranceDefault = {
  type: "",
  currency: "",
  pavement: "0",
  van: "0",
  bag: "0",
};
export const denominationDefault = {
  currency: null,
  multiple: null,
  noOfCassettes: "0",
  noOfNotes: "0",
};
export const replenishmentModelsDefault = {
  code: "",
  ...denominationDefault,
  denominations: [],
  models: [],
};
export const contractSLADefault = {
  country: "",
  region: "",
  serviceType: "",
  activityType: "",
  responseTime: "",
  attendedTime: "",
  resolutionTime: "",
};
export const invoicingCatalogDefault = {
  invoicingCode: "",
  currency: "",
  rate: "0",
  discount: "0",
};

export const contractsDefault = {
  ...contractSLADefault,
  ...invoicingCatalogDefault,
  contractCode: "",
  autoRenew: true,
  autoRenewFor: "0",
  startDate: new Date(),
  endDate: new Date(),
  status: "",
  contractSLAs: [],
  invoicingCatalogs: [],
};
export const cassettesDefault = {
  description: "",
  cassetteCurrency: "",
  cassetteMultiple: "",
  cassetteType: "",
  maker: "",
  limit: "0",
  dualScanning: true,
};
export const servicesDenominationDefault = {
  denominationCurrency: "",
  denominationMultiple: "",
  shape: "",
  version: "",
};
export const offeredServicesDefault = {
  serviceName: "",
  denominations: [],
  cassettes: [],
  offeredServices: [],
  ...servicesDenominationDefault,
  ...cassettesDefault,
};
export const escalationGroupDefault = {
  region: "",
  routeNo: "",
  escalationLevel: "",
  inAppRecipient: "",
  emailRecipient: "",
  callRecipient: "",
  inAppRecipients: [],
  emailRecipients: [],
  callRecipients: [],
};
export const emptyCustomer = {
  ...customerInfoDefault,
  accounts: [],
  contactPersons: [],
  insuranceLimits: [],
  replenishmentModels: [],
  contracts: [],
  offeredServices: [],
  escalationGroups: [],
  locationInitials: [],
  lastCallTimings: [],
  serviceWindows: [],
};

export const formValidationRules = {};
export const SERVICES_NAME = [
  { value: "Replenishment", label: "Replenishment" },
  { value: "Clearance", label: "Clearance" },
  {
    value: "Kiosk",
    label: "Kiosk",
  },
];
